import {Logic} from "./SuggestionsPopup.interfaces";
import "./SuggestionsPopup.styles.scss";
import {
    Button,
    Checkbox,
    Flex,
    Image,
    Input,
    Popup,
    SearchIcon,
    Skeleton,
    Text,
    WandIcon
} from "@fluentui/react-northstar";
import languageObject from "../../../../translations";
import * as React from "react";
import {useMemo} from "react";
import {brandColors} from "../../../../const/ThemeCustomizations";

export const SuggestionsPopupRendering = (logic: Logic) => {

    const trigger = useMemo(() => (
        <Button
            disabled={logic.disableTrigger}
            content={languageObject.translate("Suggestions")}
            icon={<WandIcon/>}
        />
    ), [logic.disableTrigger]);

    const skeletons = useMemo(() => (
        Array.from({length: 6}).map((_, i) => (
            <Skeleton key={"skeleton" + i} animation={"pulse"}>
                <Skeleton.Shape width={"100%"} height={"100px"} styles={{margin: 0, borderRadius: "3px"}}/>
            </Skeleton>
        ))
    ), []);

    const creativeCommonCheckbox = useMemo(() => (
        <Flex>
            <Checkbox
                toggle
                checked={logic.creativeCommonOnly}
                label={languageObject.translate("ImagesUnderCreativeCommonLicense")}
                onChange={logic.handleToggleImageLicence}
            />
        </Flex>
    ), [logic.creativeCommonOnly])

    const keywordsInput = useMemo(() => (
        <Flex>
            <Input
                fluid icon={<SearchIcon/>} iconPosition={"end"}
                placeholder={languageObject.translate("Keywords")}
                onChange={logic.handleChangeKeywords}
                value={logic.keywords}
            />
        </Flex>
    ), [logic.keywords]);

    const thumbnails = useMemo(() => (
        <Flex column className={"suggestion-thumbnails-container"}>
            {logic.isLoading ? skeletons :
                logic.suggestions?.map(s => (
                    <Image
                        key={s.url}
                        src={s.thumbnailUrl}
                        alt={s.name}
                        className={"suggestion-thumbnail"}
                        onClick={logic.handleSelectSuggestion(s)}
                    />
                ))
            }
        </Flex>
    ), [logic.isLoading, logic.suggestions]);

    const header = useMemo(() => (
        <Flex column styles={{gap: "3px"}}>
            <Text size={"large"} weight={"semibold"}
                  content={languageObject.translate("SuggestionsFoundByCopilot")}/>
            <Text styles={{color: "darkgray"}} size={"small"}
                  content={languageObject.translate("PoweredByBing")}/>
        </Flex>
    ), []);

    const legalText = useMemo(() => (
        <Flex styles={{gap: "5px"}} vAlign={"center"}>
            <Text size={"small"} content={languageObject.translate("SuggestionsRightsMessage")}/>
            <a href={"https://www.microsoft.com/en-us/legal/intellectualproperty/copyright"}
               target={"_blank"}
               style={{textDecoration: "none"}}>
                <Text size={"small"} styles={{color: brandColors[600]}}
                      content={languageObject.translate("LearnMoreHere")}/>
            </a>
        </Flex>
    ), []);

    const content = (
        <Flex column className={"suggestions-popup-container"} gap={"gap.small"}>
            {header}
            {creativeCommonCheckbox}
            {keywordsInput}
            {thumbnails}
            {legalText}
        </Flex>
    )

    return (
        <Popup
            popperRef={logic.popperRef}
            pointing
            align={"end"}
            onOpenChange={logic.handleOpenChange(logic.message)}
            trigger={trigger}
            content={content}
        />
    )
}